import { endpoint } from './endpoint';
import fetch from 'isomorphic-unfetch';

export async function validateEmail({
  email,
  source,
}: {
  email: string;
  source: string;
}) {
  const url = endpoint + `/v1/validate-email/?email=${email}&source=${source}`;
  const init = {
    method: 'get',
    headers: new Headers({
      'Content-Type': 'application/json',
    }),
  };
  return fetch(url, init).then((res) => res.json());
}
